export default {
  showTextNoteSummary: true,
  showTextNoteTitle: true,
  activeRequests: 0,
  notifyGranted: null,
  leftColumnWidth: 0,
  rightColumnWidth: 0,
  preferences: {},
};
